import { z } from "zod";

export const OnsiteInjectionDtoSchema = z.object({
  id: z.string().uuid(),
  variationId: z.string().uuid(),
  customCss: z.preprocess(
    (x) => (typeof x === "object" ? x?.toString() : x),
    z.string().nullish()
  ),
  customJs: z.preprocess(
    (x) => (typeof x === "object" ? x?.toString() : x),
    z.string().nullish()
  ),
});

export type OnsiteInjectionDto = z.infer<typeof OnsiteInjectionDtoSchema>;

export const CreateOnsiteInjectionDtoSchema = OnsiteInjectionDtoSchema.extend({
  id: z.string().uuid().optional(),
});
export type CreateOnsiteInjectionDto = z.infer<
  typeof CreateOnsiteInjectionDtoSchema
>;
